export default defineNuxtRouteMiddleware(() => {
  const user = useSupabaseUser();
  if (!isInternalUserEmail(user.value?.email ?? "")) {
    return navigateTo("/");
  }
});
